/*eslint-disable */
const trigger = (el, type) => {
	const e = document.createEvent('HTMLEvents')
	e.initEvent(type, true, true)
	el.dispatchEvent(e)
};

export default {
	created (el, binding, vNode) {
		if (binding.value === false) {
			return;
		}
		let len = binding.value;
		const input = el.getElementsByTagName('input')[0]
		input.onkeyup = function (e) {
			input.value = vNode.context.$XEUtils.DoubleInput(input.value, len, false)
			trigger(input, 'input');
		}
		input.onblur = function (e) {
			input.value = vNode.context.$XEUtils.DoubleInput(input.value, len, false)
			trigger(input, 'input');
		}
	}
};